import React from "react";
import { Toaster } from "@os/components/ui/toaster";
import { Toaster as Sonner } from "@os/components/ui/sonner";
import { TooltipProvider } from "@os/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const EmbeddedApp: React.FC = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      {/* Use parent Router; define MapleOS routes relative to /desktop/start */}
      <Routes>
        <Route path="/" element={<Index />} />
        {/* ADD ALL CUSTOM OS ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </TooltipProvider>
  </QueryClientProvider>
);

export default EmbeddedApp;